import { useLayoutEffect } from 'react';

const TAP_SLOP_PX = 3;

const isDragHandleTarget = (node) =>
  Boolean(node?.closest?.('[data-drag-role="mobile-grip"]'));

/**
 * WebView (iPad/Android tablet): overflow:scroll spesso non pan-na col dito.
 * Muoviamo noi scrollTop/Left e blocchiamo il gesture nativo dopo il primo spostamento.
 * La maniglia drag resta esclusa così lo spostamento prenotazione continua a funzionare.
 */
const useForcedTouchScroll = (containerRef, enabled) => {
  useLayoutEffect(() => {
    if (!enabled) return undefined;
    const el = containerRef.current;
    if (!el) return undefined;

    const gesture = {
      active: false,
      panning: false,
      startX: 0,
      startY: 0,
      scrollLeft: 0,
      scrollTop: 0,
    };

    const onTouchStart = (event) => {
      if (event.touches.length !== 1 || isDragHandleTarget(event.target)) {
        gesture.active = false;
        gesture.panning = false;
        return;
      }
      const touch = event.touches[0];
      gesture.active = true;
      gesture.panning = false;
      gesture.startX = touch.clientX;
      gesture.startY = touch.clientY;
      gesture.scrollLeft = el.scrollLeft;
      gesture.scrollTop = el.scrollTop;
    };

    const onTouchMove = (event) => {
      if (!gesture.active || event.touches.length !== 1) return;
      const touch = event.touches[0];
      const dx = touch.clientX - gesture.startX;
      const dy = touch.clientY - gesture.startY;
      if (!gesture.panning) {
        if (Math.abs(dx) < TAP_SLOP_PX && Math.abs(dy) < TAP_SLOP_PX) return;
        gesture.panning = true;
      }
      if (event.cancelable) event.preventDefault();
      el.scrollLeft = gesture.scrollLeft - dx;
      el.scrollTop = gesture.scrollTop - dy;
    };

    const onTouchEnd = () => {
      gesture.active = false;
      gesture.panning = false;
    };

    el.addEventListener('touchstart', onTouchStart, { passive: true });
    el.addEventListener('touchmove', onTouchMove, { passive: false });
    el.addEventListener('touchend', onTouchEnd, { passive: true });
    el.addEventListener('touchcancel', onTouchEnd, { passive: true });

    return () => {
      gesture.active = false;
      el.removeEventListener('touchstart', onTouchStart);
      el.removeEventListener('touchmove', onTouchMove);
      el.removeEventListener('touchend', onTouchEnd);
      el.removeEventListener('touchcancel', onTouchEnd);
    };
  }, [containerRef, enabled]);
};

export default useForcedTouchScroll;
